import { info } from "@randajan/simple-app/info";

import jet from "@randajan/jet-core";
import store from "@randajan/jet-react/base/store";

import { bifrost } from "../bifrost";


store.watch("locale", async get=>{
    const resp = await bifrost.tx("/locale/set", { target:"browser", value:get() });
});

export {
    store
}